export default "__VITE_ASSET__CWAkzNgu__"